import { render, staticRenderFns } from "./PaymentComment.vue?vue&type=template&id=07c13113&scoped=true"
import script from "./PaymentComment.vue?vue&type=script&lang=js"
export * from "./PaymentComment.vue?vue&type=script&lang=js"
import style0 from "./PaymentComment.vue?vue&type=style&index=0&id=07c13113&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c13113",
  null
  
)

export default component.exports